// extracted by mini-css-extract-plugin
module.exports = {"icon":"_1UJnU","linkActive":"_1yJR9","bubble":"_3HUDA","heart":"XzVf_"};